import React, { useEffect, useState } from 'react'; // useState 추가
import DrawerTemplate from '../../components/common/drawer/DrawerTemplate';
import DrawerTemplateCar from '../../components/common/drawer/DrawerTemplateCar';
import ScrollTop from '../../components/common/footer/ScrollTop';

const MainPage = (props) => {
  const [mode, setMode] = useState(null);

  useEffect(() => {
    const loginMode = localStorage.getItem('loginMode');
    setMode(loginMode);
  }, []); 

  return (
    <>
      <div id="back-to-top-anchor"></div>
      {mode === 'car_service' ? (
        <DrawerTemplateCar />
      ) : (
        <DrawerTemplate />
      )}
      
      <ScrollTop {...props} />
    </>
  );
};

export default MainPage;
